export default "__VITE_ASSET__CeyaJqdA__"